import { render, staticRenderFns } from "./IconMonitor.vue?vue&type=template&id=4445d1ee&"
import script from "./IconMonitor.vue?vue&type=script&lang=js&"
export * from "./IconMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports